import { render, staticRenderFns } from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=template&id=65005c4a"
import script from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroMovimientoArmaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports